import { IsAlert } from "../component/atoms/IsAlert";
import AccelerometerImage from "../pages/assets/icons/ic_acc.png";
import GyroImage from "../pages/assets/icons/ic_gyro.png";
import LvdtImage from "../pages/assets/icons/ic_lvdt.png";
import StrainImage from "../pages/assets/icons/ic_straingauge.jpg";
import IconDefaultImage from "../pages/assets/icons/ic_def.png";
import PduImage from "../pages/assets/icons/ic_pdu.png";

const getBase64 = (file) => {
  return new Promise((resolve) => {
    let baseURL = "";
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};
const kesehatanWarna = (e) => {
  var warna = "";
  if (e === 1) {
    warna = "#5BC673";
  } else if (e === 3) {
    warna = "#d9534f";
  } else if (e === 2) {
    warna = "#ffb834";
  } else {
    warna = "#ccc";
  }
  return warna;
};
const bulan = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agust",
  "Sep",
  "Okt",
  "Nov",
  "Dev",
];
const tahun = [
  "2001",
  "2002",
  "2003",
  "2004",
  "2005",
  "2006",
  "2007",
  "2008",
  "2009",
];
const hari = () => {
  var jumlah = [];
  for (let i = 1; i < 31; i++) {
    jumlah.push(i);
  }
  return jumlah;
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

const getBulanName = (bulan) => {
  switch (parseInt(bulan)) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "Mei";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Agu";
    case 9:
      return "Sep";
    case 10:
      return "Okt";
    case 11:
      return "Nov";
    case 12:
      return "Des";
    default:
      break;
  }
};

const pesanCallback = (status, res, callback) => {
  if (status == 200) {
    return IsAlert.fire({
      title: "",
      text: res.message,
      icon: "success",
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: "OK",
      showCancelButton: false,
    }).then(function (isConfirm) {
      if (isConfirm.isConfirmed) {
        callback();
      }
    });
  } else {
    return IsAlert.fire({
      title: "",
      text: res.message,
      icon: "error",
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: "OK",
    }).then(function (isConfirm) {
      if (isConfirm.isConfirmed) {
        callback();
      }
    });
  }
};

const getAvatarUsername = (string) => string.substring(0, 1).toUpperCase();

const isRoleHasAcces = (allowedRoles, userRole) => {
  return allowedRoles.includes(userRole);
};

const getFullTime = (ts) => {
  const time = new Date(ts);
  return time.toLocaleString();
};

const getDay = (ts) => {
  const weekday = [
    "Minggu",
    "Senin",
    "Selasa",
    "Rabu",
    "Kamis",
    "Jumat",
    "Sabtu",
  ];
  const time = new Date(ts);
  return weekday[time.getDay()];
};

const renderSensorIcon = (group) => {
  switch (group) {
    case "Accelerometer":
      return AccelerometerImage;
    case "Gyroscope":
      return GyroImage;
    case "LVDT":
      return LvdtImage;
    case "Strain":
      return StrainImage;
    case "Power Distribution":
      return PduImage;
    default:
      return IconDefaultImage;
  }
};

const ReadableTime = (timestamp) => {
  let dift_s = (new Date().getTime() - new Date(timestamp).getTime()) / 1000;
  let dift_d = Math.floor(dift_s / 86400);

  switch (true) {
    case dift_d === 0:
      switch (true) {
        case dift_s < 10:
          return "sekarang";
        case dift_s < 60:
          return String(Math.floor(dift_s)) + " detik lalu";
        case dift_s < 3600:
          return String(Math.floor(dift_s / 60)) + " menit lalu";
        case dift_s < 86400:
          return String(Math.floor(dift_s / 3600)) + " jam lalu";
        default:
          break;
      }
      return "sekarang";
    case dift_d === 1:
      return "kemarin";
    case dift_d < 7:
      return String(dift_d) + " beberapa hari lalu";
    case dift_d < 31:
      return String(Math.floor(dift_d / 7)) + " minggu lalu";
    case dift_d < 365:
      return String(Math.floor(dift_d / 31)) + " bulan lalu";
    case dift_d > 365:
      return String(Math.floor(dift_d / 365)) + " tahun lalu";
    default:
      break;
  }
};

export {
  getBase64,
  kesehatanWarna,
  bulan,
  tahun,
  hari,
  getCookie,
  deleteAllCookies,
  getBulanName,
  pesanCallback,
  isRoleHasAcces,
  getAvatarUsername,
  getFullTime,
  getDay,
  renderSensorIcon,
  ReadableTime,
};
